<work-view
  [backlogTasks]="workContextService.backlogTasks$|async"
  [doneTasks]="workContextService.doneTasks$|async"
  [isShowBacklog]="isShowBacklog$|async"
  [undoneTasks]="workContextService.undoneTasks$|async"
></work-view>
